import { render, staticRenderFns } from "./ListesProduitsView.vue?vue&type=template&id=82696476"
import script from "./ListesProduitsView.vue?vue&type=script&lang=js"
export * from "./ListesProduitsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports